// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/views/bo-core/forbidden/forbiddenPage.css
// module id = 788
// module chunks = 1